/* <accordion-list>: FAQ accordion. With data-single-open only one answer is open at a time (prototype FAQ).
   data-group="<name>" extends that across separate lists with the same group (product page dropdowns, one list per block).
   Items: .accordion__item > .accordion__trigger[aria-controls] + .accordion__panel (inert when closed). */
if (!customElements.get('accordion-list')) {
  customElements.define('accordion-list', class AccordionList extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', e => {
        const trigger = e.target.closest('.accordion__trigger');
        if (!trigger || !this.contains(trigger)) return;
        const item = trigger.closest('.accordion__item');
        const open = !item.classList.contains('is-open');
        if (this.hasAttribute('data-single-open')) this.siblingItems.forEach(([list, i]) => i !== item && list.set(i, false));
        this.set(item, open);
      });
    }
    get items() { return [...this.querySelectorAll(':scope > .accordion__item')]; }
    get siblingItems() {
      const group = this.dataset.group;
      const lists = group ? [...document.querySelectorAll('accordion-list[data-group]')].filter(l => l.dataset.group === group) : [this];
      return lists.flatMap(list => list.items.map(i => [list, i]));
    }
    set(item, open) {
      item.classList.toggle('is-open', open);
      item.querySelector('.accordion__trigger')?.setAttribute('aria-expanded', open);
      item.querySelector('.accordion__panel')?.toggleAttribute('inert', !open);
    }
  });
}
